import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../App';
import './Landing.css';

export default function Landing() {
  const { token } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="landing">
      {/* ── Header minimal ── */}
      <header className="landing-header">
        <div className="landing-header-inner">
          <div className="landing-logo">
            <img src="/logo.png" alt="FastBox" className="landing-logo-img"
              onError={e => { e.target.style.display = 'none'; }} />
            <span className="landing-logo-text">Fast Box</span>
          </div>
          <nav className="landing-nav">
            {token ? (
              <button className="btn-primary" onClick={() => navigate('/shop')}>
                <i className="fa-solid fa-store" /> Accéder à la boutique
              </button>
            ) : (
              <a href="/api/auth/discord" className="btn-discord">
                <i className="fa-brands fa-discord" /> Se connecter
              </a>
            )}
          </nav>
        </div>
      </header>

      {/* ── Hero ── */}
      <section className="landing-hero">
        <div className="hero-badge">
          <i className="fa-solid fa-bolt" /> NexaRP · Livraison instantanée
        </div>
        <h1 className="hero-title">
          Commandez. <span className="text-red">Récupérez.</span><br />
          C'est aussi simple que ça.
        </h1>
        <p className="hero-desc">
          Achetez vos produits en ligne et récupérez-les dans une <strong>FastBox</strong> à
          travers tout Los Santos. Paiement sécurisé via votre compte Fleeca Bank.
        </p>
        <div className="hero-actions">
          {token ? (
            <button className="btn-primary hero-btn" onClick={() => navigate('/shop')}>
              <i className="fa-solid fa-store" /> Voir la boutique
            </button>
          ) : (
            <a href="/api/auth/discord" className="btn-discord hero-btn">
              <i className="fa-brands fa-discord" /> Connexion Discord
            </a>
          )}
          {token && (
            <button className="btn-secondary hero-btn" onClick={() => navigate('/orders')}>
              <i className="fa-solid fa-box-open" /> Mes commandes
            </button>
          )}
        </div>
      </section>

      {/* ── Features ── */}
      <section className="landing-features">
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">
              <i className="fa-solid fa-shield-halved" />
            </div>
            <h3>Paiement sécurisé</h3>
            <p>Votre argent est prélevé directement sur votre compte Fleeca Bank. Aucun risque de fraude.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <i className="fa-solid fa-location-dot" />
            </div>
            <h3>7 FastBoxes</h3>
            <p>Des points de retrait répartis dans tout Los Santos. Trouvez la boîte la plus proche.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <i className="fa-solid fa-bolt" />
            </div>
            <h3>Livraison instantanée</h3>
            <p>Votre commande est disponible dès validation. Plus besoin d'attendre !</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <i className="fa-solid fa-key" />
            </div>
            <h3>Code unique</h3>
            <p>Un code personnel sécurisé vous est attribué pour chaque commande. Personne d'autre ne peut l'ouvrir.</p>
          </div>
        </div>
      </section>

      {/* ── How it works ── */}
      <section className="landing-how">
        <h2 className="section-title">Comment ça marche ?</h2>
        <div className="how-steps">
          <div className="how-step">
            <div className="step-number">1</div>
            <div>
              <h4>Connectez-vous</h4>
              <p>Utilisez votre compte Discord lié au serveur NexaRP.</p>
            </div>
          </div>
          <div className="how-arrow"><i className="fa-solid fa-arrow-right" /></div>
          <div className="how-step">
            <div className="step-number">2</div>
            <div>
              <h4>Choisissez vos produits</h4>
              <p>Parcourez le catalogue et ajoutez au panier.</p>
            </div>
          </div>
          <div className="how-arrow"><i className="fa-solid fa-arrow-right" /></div>
          <div className="how-step">
            <div className="step-number">3</div>
            <div>
              <h4>Validez la commande</h4>
              <p>Paiement Fleeca Bank sécurisé en un clic.</p>
            </div>
          </div>
          <div className="how-arrow"><i className="fa-solid fa-arrow-right" /></div>
          <div className="how-step">
            <div className="step-number">4</div>
            <div>
              <h4>Récupérez en FastBox</h4>
              <p>Rendez-vous à la FastBox indiquée et entrez votre code.</p>
            </div>
          </div>
        </div>
      </section>

      <footer className="landing-footer">
        <p>© 2026 NexaRP — Fast Box · Propulsé par Fleeca Bank</p>
      </footer>
    </div>
  );
}
